import { MonoTypeOperatorFunction, pipe, retry, timer } from 'rxjs';

export function retryServerError<T>(
  count: number,
  interval: number,
): MonoTypeOperatorFunction<T> {
  return pipe(
    retry({
      count,
      delay: (error, retryCount) => {
        // Condition: Only retry if it's a 500 server error or an unknown error
        if (errorIsUnknownOr500(error.metadata?.http?.status)) {
          return timer(interval * retryCount);
        }

        // throwing error in-case of wrong password or user not found
        throw error;
      },
    }),
  );
}

function errorIsUnknownOr500(statusCode: number | undefined): boolean {
  if (statusCode === undefined || statusCode === null) {
    return true;
  }
  return statusCode.toString(10).startsWith('5') || statusCode === 0;
}
